module.exports = __webpack_public_path__ + "static/img/icon h pdfys 1.a42b1648.svg";